/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CountyCollectionResponse as BackendCoreApiModelsAppBookingCountyCollectionResponse } from '../models/Backend/Core/Api/Models/App/Booking/county-collection-response';
import { StringCollectionResponse as BackendCoreApiModelsAppBookingStringCollectionResponse } from '../models/Backend/Core/Api/Models/App/Booking/string-collection-response';

@Injectable({
  providedIn: 'root',
})
export class MasterBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getContractTypes
   */
  static readonly GetContractTypesPath = '/api/master/contract-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContractTypes$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContractTypes$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetContractTypesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getContractTypes$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContractTypes$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingStringCollectionResponse> {

    return this.getContractTypes$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingStringCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContractTypes$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContractTypes$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetContractTypesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getContractTypes$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContractTypes$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingStringCollectionResponse> {

    return this.getContractTypes$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingStringCollectionResponse)
    );
  }

  /**
   * Path part for operation getCounties
   */
  static readonly GetCountiesPath = '/api/master/counties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounties$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounties$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetCountiesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounties$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounties$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingCountyCollectionResponse> {

    return this.getCounties$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingCountyCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCounties$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounties$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetCountiesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCounties$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCounties$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingCountyCollectionResponse> {

    return this.getCounties$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingCountyCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingCountyCollectionResponse)
    );
  }

  /**
   * Path part for operation getQualificationTypes
   */
  static readonly GetQualificationTypesPath = '/api/master/qualification-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQualificationTypes$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualificationTypes$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetQualificationTypesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getQualificationTypes$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualificationTypes$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingStringCollectionResponse> {

    return this.getQualificationTypes$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingStringCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQualificationTypes$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualificationTypes$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, MasterBackendService.GetQualificationTypesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getQualificationTypes$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQualificationTypes$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingStringCollectionResponse> {

    return this.getQualificationTypes$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingStringCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingStringCollectionResponse)
    );
  }

}
